import { AfterViewInit, Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { SharedModule } from '../SharedModule';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {
  user !: string;
  name !: string;
  constructor() { }

  ngOnInit(): void {
    this.user = localStorage.getItem('user')!;
    this.name = localStorage.getItem('name')!;
  }

  ngAfterViewInit(): void {
    $(".right-side-toggle").click(function () {
      $(".right-sidebar").slideDown(50), $(".right-sidebar").toggleClass("shw-rside")
    });
    $(".nav-lock").unbind();
    $(".nav-lock").on("click", function () {
      $("body").toggleClass("lock-nav"), $(".nav-lock i").toggleClass("mdi-toggle-switch-off"), $("body, .page-wrapper").trigger("resize")
    });
  }
}
